import { DataTable, MainButton, PageWrapper, STATUSPAGE } from '@repo/ui';
import { useEffect } from 'react';
import { Card, CardBody } from 'reactstrap';

import { makeInternshipLocationsListColumns } from '../common/columns/internship-locations-list-columns';
import { useInternshipLocationsList } from '../hooks/use-internship-locations-list';

export const InternshipLocationsList = () => {
  const {
    listStatus,
    paginationMetadata,
    internshipLocationsListData,
    debouncedRequestGetAllInternshipLocations,
    navigate,
    setListStatus,
    handlePageChange,
    handleSortRemote,
    handleSearchRemote,
    handleRowsPerPageChange,
    requestDeleteInternshipLocation,
  } = useInternshipLocationsList();

  useEffect(() => {
    const valuesToSubmit = {
      page: paginationMetadata.selectedPage.toString(),
      length: paginationMetadata.rowsPerPage.toString(),
      sortDirection: paginationMetadata.sortDirection,
      sortBy: paginationMetadata.orderColumn,
      search: encodeURIComponent(paginationMetadata.searchString),
    };
    setListStatus(STATUSPAGE.LOADING);

    debouncedRequestGetAllInternshipLocations(valuesToSubmit);
  }, [paginationMetadata]);

  // Constants
  const noDataConfig = {
    noDataTitle: 'Nenhum local de estágio encontrado',
    noDataDescription: 'Não há locais de estágio cadastrados no momento.',
  };

  return (
    <PageWrapper title="Locais de Estágio">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <div>
          <h4 className="fw-bold">Locais de Estágio</h4>
          <p className="text-muted mb-0">
            Cadastre aqui os locais que os estagiários poderão trabalhar
          </p>
        </div>

        <MainButton
          onClick={() => {
            navigate('/cadastros/locais-de-estagio/novo');
          }}
        >
          <i className="ri-add-line" style={{ fontSize: '1rem' }}></i>
          Novo Local de Estágio
        </MainButton>
      </div>

      <Card>
        <CardBody>
          <DataTable
            noDataTitle={noDataConfig.noDataTitle}
            noDataDescription={noDataConfig.noDataDescription}
            actions={[
              {
                id: 1,
                name: 'edit',
                label: 'Editar',
                onPress: (cellProps) => {
                  navigate(
                    `/cadastros/locais-de-estagio/editar/${cellProps.id}`,
                  );
                },
                classNameColorIcon: 'primary',
                nameFeatherIcon: 'edit',
              },
            ]}
            canSearch
            searchServer
            onSearch={handleSearchRemote}
            columns={makeInternshipLocationsListColumns()}
            data={internshipLocationsListData?.data}
            loading={listStatus === STATUSPAGE.LOADING}
            pagination
            handleDelete={(id) => requestDeleteInternshipLocation({ id })}
            paginationServer
            paginationTotalRows={internshipLocationsListData?.total}
            onChangePage={handlePageChange}
            onChangeRowsPerPage={handleRowsPerPageChange}
            sortServer
            onSort={handleSortRemote}
          />
        </CardBody>
      </Card>
    </PageWrapper>
  );
};
